const MAP = {
  paid: ["Pago", "bg-emerald-500/15 text-emerald-400 border-emerald-500/30"],
  pending: ["Pendente", "bg-amber-500/15 text-amber-400 border-amber-500/30"],
  pending_approval: ["Aguardando aprovação", "bg-amber-500/15 text-amber-400 border-amber-500/30"],
  rejected: ["Recusado", "bg-rose-500/15 text-rose-400 border-rose-500/30"],
  failed: ["Falhou", "bg-rose-500/15 text-rose-400 border-rose-500/30"],
  expired: ["Expirado", "bg-slate-500/15 text-slate-400 border-slate-500/30"],
  success: ["Sucesso", "bg-emerald-500/15 text-emerald-400 border-emerald-500/30"],
  blocked: ["Bloqueado", "bg-rose-500/15 text-rose-400 border-rose-500/30"],
};

export const StatusBadge = ({ status, testId }) => {
  const [label, cls] = MAP[status] || [status, "bg-cyan-500/15 text-cyan-400 border-cyan-500/30"];
  return (
    <span data-testid={testId} className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold ${cls}`}>
      {label}
    </span>
  );
};

export const ZeroFeeBadge = () => (
  <span data-testid="zero-fee-badge" className="zero-fee">
    <span className="h-1.5 w-1.5 rounded-full bg-emerald-400 animate-pulse" /> Taxa 0% em depósitos e saques
  </span>
);
